import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApplicationService } from '../../services/application.service';
import { AppService } from '../../services/app.service';

import { HistoryComponentBase } from './HistoryComponentBase';

@Component({
    selector: 'app-application-person-documents-history',
    templateUrl: './person-documents.component.html'
})
export class ApplicationPersonDocumentsHistoryComponent extends HistoryComponentBase {
    constructor(
        public app: AppService,
        protected service: ApplicationService,
        protected route: ActivatedRoute
    ) {
        super(app, service, route);
    }

    get getData() {
         return this.service.getPersonDocumentsHistory(this.item.Id);
    }
}
